<template>
    <v-app id="inspire">
        <v-navigation-drawer
            v-model="drawer"
            app
            mini-variant
            :right="$vuetify.rtl"
            expand-on-hover>
            <NavDrawerList :groups="navList"/>
        </v-navigation-drawer>
        <v-app-bar
            app
            dense
            elevation="1"
            color="white">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title><span class="font-weight-bold">{{ warehouse && warehouse.name ? warehouse.name : null }}</span> / {{$t("inventory_management")}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <ToolbarMenuRight/>
        </v-app-bar>
        <v-main>
            <router-view></router-view>
        </v-main>
        <QuickNavDialog v-model="quickNav"/>
        <LoadingDialog message="Please Wait ..." v-model="loading"/>
          <v-snackbar :value="snackbar.display" @input="hideSnackbar" :color="snackbar.color" bottom right>{{snackbar.text}}</v-snackbar>
    </v-app>
</template>

<script>
import QuickNavDialog from './../components/common/QuickNavDialog';
import ToolbarMenuRight from '@/components/common/ToolbarMenuRight'
import NavDrawerList from './../components/common/NavDrawerList';
import LoadingDialog from './../components/common/LoadingDialog';
import { mapGetters, mapActions } from 'vuex';
import permissions from './../data/permissions';
import { getWarehouse } from './../services/stock/warehouse';

export default {
    components: {
        ToolbarMenuRight,
        // PFooter,
        NavDrawerList,
        QuickNavDialog,
        LoadingDialog
    },
    data() {
        return {
            interval: null,
            hotdial: null,
            drawer: null,
            loading: false,
            quickNav: false,
            perm: permissions,
            warehouseId: null,
            warehouse: null,
        }
    },
    watch: {

    },
    computed: {
        ...mapGetters({
            snackbar: "ui/snackbar/snackbar",
            itemPerm: "stock/permission/item",
            measureUnitPerm: "stock/permission/measureUnit",
            warehousePerm: "stock/permission/warehouse",
            itemGroupPerm: "stock/permission/itemGroup",
            reportsPerm: "stock/permission/reports",
            stockAdjustmentPerm: "stockJournal/permission/stockAdjustment",
            goodsIssuePerm: "stockJournal/permission/goodsIssue",
            goodsReceiptPerm: "stockJournal/permission/goodsReceipt",
            hasPermission: "authentication/hasPermission"
        }),
        navList() {
            return [
                {
                    text: this.$t('purchases'),
                    icon: 'mdi-folder',
                    items: [
                        {
                            text: this.$t("purchase_requisitions"),
                            icon: "mdi-file-document-edit-outline",
                            authorization: this.perm.stock_movement.read,
                            to: `/warehouse/${this.warehouseId}/requisitions`
                        },
                        {
                            text: this.$t("purchase_orders"),
                            icon: "mdi-order-bool-ascending-variant",
                            to:`/warehouse/${this.warehouseId}/orders`,
                            authorization: this.perm.stock_movement.read,

                        }
                    ]

                },
                {
                    text: this.$t("stock_movements"),
                    icon: 'mdi-folder',
                    items: [
                        {
                            text: this.$t("stock_adjustment"),
                            icon: "mdi-adjust",
                            authorization: this.perm.stock_adjustment.index,
                            to: `/warehouse/${this.warehouseId}/adjustments`
                        },
                        {
                            text: this.$t("good_receipts"),
                            icon: "mdi-archive",
                            authorization: this.perm.stock_movement.read,
                            to: `/warehouse/${this.warehouseId}/receipts`
                        } ,
                        {
                            text: this.$t("stock_issue_voucher"),
                            icon: "mdi-arrow-down-bold",
                            authorization: this.perm.good_issue.index,
                            to: `/warehouse/${this.warehouseId}/goods-issue-vouchers`
                        }
                    ]
                },
                {
                    text: this.$t("stock_transfer"),
                    icon: 'mdi-folder',
                    items: [
                        {
                            text: this.$t("stock_transfer_voucher"),
                            icon: "mdi-arrow-up",
                            authorization: this.perm.stock_transfer.index,
                            to: `/warehouse/${this.warehouseId}/stock-transfer-vouchers`
                        },
                        {
                            text: this.$t("incomming_stock_transfer"),
                            icon: "mdi-circle",
                            authorization: this.perm.stock_transfer.index,
                            to: `/warehouse/${this.warehouseId}/stock-incoming-transfers`
                        },
                        {
                            text: this.$t("stock_transfer_receipts"),
                            icon: "mdi-arrow-down",
                            authorization: this.perm.stock_transfer_receipt.index,
                            to: `/warehouse/${this.warehouseId}/stock-transfer-receipts`
                        }
                    ]
                },
                {
                    text: this.$t("reports"),
                    icon: 'mdi-folder',
                    items: [
                        {
                            text: this.$t("stock_movement"),
                            icon: "mdi-poll",
                            authorization: this.perm.stock_movement.read,
                            to: `/warehouse/${this.warehouseId}/stock-movement`
                        },
                        {
                            text: this.$t("stock_on_hand_by_item"),
                            icon: "mdi-poll",
                            authorization: this.perm.stock_on_hand_item.read,
                            to: `/warehouse/${this.warehouseId}/stock-on-hand-item`
                        },
                        {
                            text: this.$t("stock_on_hand_by_warehouse"),
                            icon: "mdi-poll",
                            authorization: this.perm.stock_on_hand_by_warehouse.read,
                            to: `/warehouse/${this.warehouseId}/stock-on-hand-warehouse`
                        },
                        {
                            text: this.$t("stock_issued_summary"),
                            icon: "mdi-poll",
                            authorization: this.perm.stock_issued_summary.read,
                            to: `/warehouse/${this.warehouseId}/stock-issued-summary`
                        },
                        {
                            text: this.$t("stock_received_summary"),
                            icon: "mdi-poll",
                            authorization: this.perm.stock_received_summary.read,
                            to: `/warehouse/${this.warehouseId}/stock-received-summary`
                        },
                        {
                            text: this.$t("Stock_issued_by_dimension"),
                            icon: "mdi-poll",
                            authorization: this.perm.stock_issued_by_dimension.read,
                            to: `/warehouse/${this.warehouseId}/stock-issued-by-dimension`
                        }
                    ]
                },
                {
                    text: this.$t("settings"),
                    icon: "mdi-folder",
                    items: [
                        {
                            text: this.$t('item_groups'),
                            icon: "mdi-group",
                            authorization: this.perm.item_group.index,
                            to: `/warehouse/${this.warehouseId}/item-groups`
                        },
                        {
                            text: this.$t("items"),
                            icon: "mdi-package",
                            authorization: this.perm.item.index,
                            to: `/warehouse/${this.warehouseId}/items`
                        },
                        {
                            text: this.$t("warehouse_items"),
                            icon: "mdi-sack",
                            authorization: permissions.warehouse_item.index,
                            to: `/warehouse/${this.warehouseId}/warehouse-items`
                        }
                    ]
                },
            ]
        }
    },
    methods: {
        ...mapActions({
            hideSnackbar: "ui/snackbar/hide"
        }),
        bindShortcuts(e) {
            if(e.keyCode === 68 && e.ctrlKey === true) {
                e.preventDefault();
                this.quickNav = true;
            }
        },
        async fetchWarehouse() {
            this.warehouse = (await getWarehouse({id: this.warehouseId})).data;
        }
    },
    created() {
        document.addEventListener("keydown", this.bindShortcuts);
        this.warehouseId = this.$route.params.warehouseId;
        this.fetchWarehouse();
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.bindShortcuts);
    },
    async mounted() {
        this.loading = false;
        await Promise.all([
            this.$store.dispatch("stockJournal/item/fetchItems"),
            this.$store.dispatch("stockJournal/warehouse/fetchWarehouses"),
            this.$store.dispatch("stockJournal/account/fetchAccounts"),
            this.$store.dispatch("stockJournal/dimension/fetchDimensions"),
            this.$store.dispatch("stockJournal/fetchUserPermissions"),
            this.$store.dispatch("stockJournal/permission/get"),
            this.$store.dispatch("stock/itemType/get"),
            this.$store.dispatch("stock/permission/get"),
        ]);
        this.loading = false;
    }
}
</script>
